import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function BackNavButton({
  to = "",
  className = "",
  ariaLabel = "Go back",
  onClick,
}) {
  const navigate = useNavigate();
  const classes = `back-nav-btn ${className}`.trim();

  const handleClick = (event) => {
    if (typeof onClick === "function") {
      onClick(event);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/", { replace: true });
  };

  if (to) {
    return (
      <Link to={to} className={classes} aria-label={ariaLabel}>
        <span aria-hidden>←</span>
      </Link>
    );
  }

  return (
    <button type="button" className={classes} aria-label={ariaLabel} onClick={handleClick}>
      <span aria-hidden>←</span>
    </button>
  );
}

